import { DigitalRequest } from '../apis/pre-offer';
import { PreApplicationState } from '../state/pre-application.model';
import { Coords } from '../utils/coords.model';

export const createDigitalRequestBody = (
	product: number,
	preApplicationState: PreApplicationState,
) => {
	switch (product) {
		case 1:
			return createDigitalRequestBodyForCredits(preApplicationState);
		case 2:
			return createDigitalRequestBodyForInvestment(preApplicationState);
		case 3:
			return createDigitalRequestBodyForCreditCard(preApplicationState);
		default:
			return null;
	}
};

const createDigitalRequestBodyForCredits = (
	preApplicationState: PreApplicationState
): DigitalRequest => {
	return {
		id_presolicitud: preApplicationState.preApplicationId,
	};
};

const createDigitalRequestBodyForInvestment = (
	preApplicationState: PreApplicationState
): DigitalRequest => {
	return {
		id_presolicitud: preApplicationState.preApplicationId,
	};
};

const createDigitalRequestBodyForCreditCard = (
	preApplicationState: PreApplicationState
): DigitalRequest => {
	return {
		id_presolicitud: preApplicationState.preApplicationId
	};
};
